export { howItWorkChangeBg } from './howItWorkChangeBg';
export { benefitsChangeBg } from './benefitsChangeBg';
export { whyUseChangeBg } from './whyUseChangeBg';
